import type {
  TeacherType,
  BilingualFallbackType,
} from '@openeducation/oe-rn-shared-types';

import BilingualTeacherDAO from '../dao/bilingual-teacher.dao';
import type { Environment } from '../interfaces';

export abstract class BilingualTeacherService {
  static async updatePreferredTeacherType(
    env: Environment,
    personId: number,
    teacherType: TeacherType,
    fallBackLiveClassTeacherType?: BilingualFallbackType
  ) {
    if (!teacherType) {
      throw new Error('TeacherType is required');
    }

    const data = await BilingualTeacherDAO.updatePreferredTeacherType(
      env,
      personId,
      teacherType,
      fallBackLiveClassTeacherType
    );
    return data;
  }

  static async setOnboardingTaken(env: Environment, personId: number) {
    const data = await BilingualTeacherDAO.setOnboardingTaken(env, personId);
    return data;
  }
}
